export type Path = readonly (string | number)[]

export function getIn(obj: unknown, path: Path): unknown {
  let cur: unknown = obj
  for (const key of path) {
    if (cur == null) return undefined
    cur = (cur as Record<string | number, unknown>)[key]
  }
  return cur
}

/** A copy of `obj` with `value` at `path`; every object along the path is copied, nothing else is. */
export function setIn<T>(obj: T, path: Path, value: unknown): T {
  if (path.length === 0) return value as T
  const [head, ...rest] = path
  const container = (obj ?? {}) as Record<string | number, unknown>
  const copy = (Array.isArray(container) ? [...container] : { ...container }) as unknown as Record<string | number, unknown>
  copy[head] = setIn(container[head], rest, value)
  return copy as T
}

export function deleteIn<T>(obj: T, path: Path): T {
  if (path.length === 0) return obj
  const [head, ...rest] = path
  const container = (obj ?? {}) as Record<string | number, unknown>
  const copy = (Array.isArray(container) ? [...container] : { ...container }) as unknown as Record<string | number, unknown>
  if (rest.length === 0) {
    if (Array.isArray(copy)) copy.splice(head as number, 1)
    else delete copy[head]
  } else {
    copy[head] = deleteIn(container[head], rest)
  }
  return copy as T
}
